export default {"src":"/_next/static/media/area_visits_2.795db838.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};